import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
} from "reactstrap";

import card_avt from "../../../../assets/images/reviewer_image.png";
import chev_right from "../../../../assets/images/chev-right.png";
import Checkboxcircle from "../../../../assets/images/Checkbox-circle.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisH,
  faEyeSlash,
  faPencilAlt,
  faShare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

const CreateaPoll = () => {
  const [dropopen, setDropopen] = useState(false);
  const [isDisabled, setDisabled] = useState(false);
  function toggle() {
    setDropopen(!dropopen);
  }
  return (
    <>
      <Card className="review-card mt-3 nexogic_dashboard_card">
        <CardBody>
          <div className="replied-user-wrp">
            <img src={card_avt} className="avt-img" alt="#" />
            <span className="avt-name">Dr. Ramika Shetty</span>
            <span className="date">Jun 12, 2020, 15:30, Europe</span>
          </div>
          <div className="question-board">
            <div className="question-count-wrp">
              Question 1 of 4 <img src={chev_right} alt="chev-right" />
            </div>
            <FormGroup check>
              <Input name="radio1" type="radio" defaultChecked={true} id="q1" />
              <Label check htmlFor="q1" className="selected-label">
                Lorem ipsum dolor sit amet{" "}
                <span className="compete-percent">70%</span>
              </Label>
            </FormGroup>
            <FormGroup check>
              <Input name="radio1" type="radio" id="q2" />{" "}
              <Label check htmlFor="q2">
                Option one is this and that—be{" "}
                <span className="compete-percent">40%</span>
              </Label>
            </FormGroup>

            <FormGroup check>
              <Input name="radio1" type="radio" id="q3" />
              <Label check htmlFor="q3">
                Option two can be something else and selecting{" "}
                <span className="compete-percent">50%</span>
              </Label>
            </FormGroup>

            <FormGroup check>
              <Input name="radio1" type="radio" id="q4" />
              <Label check htmlFor="q4">
                Option three
                <span className="compete-percent">20%</span>
              </Label>
            </FormGroup>

            <div className="qu-footer">
              <div className="date-rev">Poll ends in &bull; 14 days</div>
              <Button className="submit-btn" color="info">
                Submit
              </Button>
            </div>
          </div>
        </CardBody>

        <Dropdown
          direction="left"
          isOpen={dropopen}
          toggle={toggle}
          className="toggle-dot"
        >
          <DropdownToggle>
            <FontAwesomeIcon icon={faEllipsisH} />
          </DropdownToggle>

          <DropdownMenu container="body" className="toggle-dropdown">
            <DropdownItem>
              <span>Share</span>

              <FontAwesomeIcon icon={faShare} />
            </DropdownItem>
            <DropdownItem>
              <span>Edit</span>
              <FontAwesomeIcon icon={faPencilAlt} />
            </DropdownItem>

            <DropdownItem onClick={function noRefCheck() {}}>
              <span> Delete</span>
              <FontAwesomeIcon icon={faTrash} />
            </DropdownItem>

            <DropdownItem onClick={function noRefCheck() {}}>
              <span> Hide poll</span>
              <FontAwesomeIcon icon={faEyeSlash} />
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Card>

      <Card className="review-card mt-3 nexogic_dashboard_card">
        <CardBody>
          <div className="replied-user-wrp">
            <img src={card_avt} className="avt-img" alt="#" />
            <span className="avt-name">Dr. Ramika Shetty</span>
            <span className="date">Jun 12, 2020, 15:30, Europe</span>
          </div>
          <div className="question-board">
            <div className="question-count-wrp">
              Question 1 of 4 <img src={chev_right} alt="chev-right" />
            </div>
            <FormGroup check>
              <Input name="radio1" type="radio" defaultChecked={true} id="q1" />
              <Label check htmlFor="q1" className="selected-label">
                Lorem ipsum dolor sit amet{" "}
                <span className="compete-percent">70%</span>
              </Label>
            </FormGroup>

            <FormGroup check>
              <Input name="radio1" type="radio" id="q2" />{" "}
              <Label check htmlFor="q2">
                Option one is this and that—be{" "}
                <span className="compete-percent">40%</span>
              </Label>
            </FormGroup>
            <FormGroup check>
              <Input name="radio1" type="radio" id="q3" />
              <Label check htmlFor="q3">
                Option two can be something else and selecting{" "}
                <span className="compete-percent">50%</span>
              </Label>
            </FormGroup>

            <FormGroup check>
              <Input name="radio1" type="radio" id="q4" />
              <Label check htmlFor="q4">
                Option three
                <span className="compete-percent">20%</span>
              </Label>
            </FormGroup>

            <div className="qu-footer">
              <div className="date-rev">Poll ends in &bull; 14 days</div>
              <Button className="submit-btn" color="info">
                Submit
              </Button>
            </div>
          </div>
        </CardBody>

        <Dropdown
          direction="left"
          isOpen={dropopen}
          toggle={toggle}
          className="toggle-dot"
        >
          <DropdownToggle>
            <FontAwesomeIcon icon={faEllipsisH} />
          </DropdownToggle>

          <DropdownMenu container="body" className="toggle-dropdown">
            <DropdownItem>
              <span>Share</span>
              <FontAwesomeIcon icon={faShare} />
            </DropdownItem>

            <DropdownItem>
              <span>Edit</span>
              <FontAwesomeIcon icon={faPencilAlt} />
            </DropdownItem>
            <DropdownItem onClick={function noRefCheck() {}}>
              <span> Delete</span>
              <FontAwesomeIcon icon={faTrash} />
            </DropdownItem>
            <DropdownItem onClick={function noRefCheck() {}}>
              <span> Hide poll</span>
              <FontAwesomeIcon icon={faEyeSlash} />
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Card>

      <Card className="review-card mt-3 nexogic_dashboard_card">
        <CardBody>
          <div className="replied-user-wrp">
            <img src={card_avt} className="avt-img" alt="#" />
            <span className="avt-name">Dr. Ramika Shetty</span>
            <span className="date">Jun 12, 2020, 15:30, Europe</span>
          </div>

          <div className="comment-texts text-center">
            Lorem ipsum dolor sit amet{" "}
          </div>

          <div className="question-board">
            <div className="question-count-wrp">
              Question 1 of 4 <img src={chev_right} alt="chev-right" />
            </div>

            <FormGroup check className="showing-ans">
              <img
                src={Checkboxcircle}
                alt="Checkbox-circle"
                className="img-fluid mr-1"
              />
              <Label check htmlFor="q1" className="selected-label">
                Lorem ipsum dolor sit amet{" "}
                <span className="compete-percent">70%</span>
              </Label>
            </FormGroup>

            <FormGroup check>
              <Label check htmlFor="q2">
                Option one is this and that—be{" "}
                <span className="compete-percent">40%</span>
              </Label>
            </FormGroup>

            <FormGroup check>
              <Label check htmlFor="q3">
                Option two can be something else and selecting{" "}
                <span className="compete-percent">50%</span>
              </Label>
            </FormGroup>

            <FormGroup check>
              <Label check htmlFor="q4">
                Option three
                <span className="compete-percent">20%</span>
              </Label>
            </FormGroup>

            <div className="qu-footer">
              <div className="date-rev">Poll ends in &bull; 14 days</div>
            </div>
          </div>
        </CardBody>

        <Dropdown
          direction="left"
          isOpen={dropopen}
          toggle={toggle}
          className="toggle-dot"
        >
          <DropdownToggle>
            <FontAwesomeIcon icon={faEllipsisH} />
          </DropdownToggle>

          <DropdownMenu container="body" className="toggle-dropdown">
            <DropdownItem>
              <span>Share</span>
              <FontAwesomeIcon icon={faShare} />
            </DropdownItem>

            <DropdownItem>
              <span>Edit</span>
              <span>Edit</span>
              <FontAwesomeIcon icon={faPencilAlt} />
            </DropdownItem>

            <DropdownItem onClick={function noRefCheck() {}}>
              <span> Delete</span>
              <FontAwesomeIcon icon={faTrash} />
            </DropdownItem>

            <DropdownItem onClick={function noRefCheck() {}}>
              <span> Hide poll</span>
              <FontAwesomeIcon icon={faEyeSlash} />
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Card>

      <Card className="review-card mt-3 nexogic_dashboard_card">
        <CardBody>
          <div className="replied-user-wrp">
            <img src={card_avt} className="avt-img" alt="#" />
            <span className="avt-name">Dr. Ramika Shetty</span>
            <span className="date">Jun 12, 2020, 15:30, Europe</span>
          </div>

          <div className="comment-texts">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem
            ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua?
          </div>

          <div className="question-board">
            <div className="question-count-wrp">
              Question 1 of 4 <img src={chev_right} alt="chev-right" />
            </div>

            <FormGroup check>
              <Input name="radio1" type="radio" defaultChecked={true} id="q1" />
              <Label check htmlFor="q1" className="selected-label">
                Lorem ipsum dolor sit amet{" "}
                <span className="compete-percent">70%</span>
              </Label>
            </FormGroup>

            <FormGroup check>
              <Input name="radio1" type="radio" id="q2" />{" "}
              <Label check htmlFor="q2">
                Option one is this and that—be{" "}
                <span className="compete-percent">40%</span>
              </Label>
            </FormGroup>

            <FormGroup check>
              <Input name="radio1" type="radio" id="q3" />

              <Label check htmlFor="q3">
                Option two can be something else and selecting{" "}
                <span className="compete-percent">50%</span>
              </Label>
            </FormGroup>

            <FormGroup check>
              <Input name="radio1" type="radio" id="q4" />

              <Label check htmlFor="q4">
                Option three
                <span className="compete-percent">20%</span>
              </Label>
            </FormGroup>

            <div className="qu-footer">
              <div className="date-rev">Poll ends in &bull; 14 days</div>

              <Button className="submit-btn" color="info">
                Leave answer
              </Button>
            </div>
          </div>
        </CardBody>

        <Dropdown
          direction="left"
          isOpen={dropopen}
          toggle={toggle}
          className="toggle-dot"
        >
          <DropdownToggle>
            <FontAwesomeIcon icon={faEllipsisH} />
          </DropdownToggle>

          <DropdownMenu container="body" className="toggle-dropdown">
            <DropdownItem>
              <span>Share</span>
              <FontAwesomeIcon icon={faShare} />
            </DropdownItem>

            <DropdownItem>
              <span>Edit</span>``
              <FontAwesomeIcon icon={faPencilAlt} />
            </DropdownItem>

            <DropdownItem onClick={function noRefCheck() {}}>
              <span> Delete</span>
              <FontAwesomeIcon icon={faTrash} />
            </DropdownItem>

            <DropdownItem onClick={function noRefCheck() {}}>
              <span> Hide poll</span>
              <FontAwesomeIcon icon={faEyeSlash} />
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Card>

      <Card className="review-card mt-3 nexogic_dashboard_card">
        <CardBody>
          <div className="replied-user-wrp">
            <img src={card_avt} className="avt-img" alt="#" />
            <span className="avt-name">Dr. Ramika Shetty</span>
            <span className="date">Jun 12, 2020, 15:30, Europe</span>
          </div>

          <div className="comment-texts">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem
            ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua?
          </div>

          <div className="question-board">
            <div className="question-count-wrp">
              Question 1 of 4 <img src={chev_right} alt="chev-right" />
            </div>
            <FormGroup check>
              <Input name="radio1" type="radio" defaultChecked={true} id="q1" />
              <Label check htmlFor="q1" className="selected-label">
                Lorem ipsum dolor sit amet
              </Label>
            </FormGroup>

            <FormGroup check>
              <Input name="radio1" type="radio" id="q2" />{" "}
              <Label check htmlFor="q2">
                Option one is this and that—be
              </Label>
            </FormGroup>

            <FormGroup check>
              <Input name="radio1" type="radio" id="q3" />

              <Label check htmlFor="q3">
                Option two can be something else and selecting
              </Label>
            </FormGroup>

            <FormGroup check>
              <Input name="radio1" type="radio" id="q4" />

              <Label check htmlFor="q4">
                lorem ipsum
              </Label>
            </FormGroup>

            <div className="qu-footer">
              <div className="date-rev">Poll ends in &bull; 14 days</div>
              <Button
                id="q-btn-submit"
                className="submit-btn"
                color={isDisabled ? "secondary" : "info"}
                disabled={isDisabled}
              >
                Submit
              </Button>
            </div>
          </div>
        </CardBody>

        <Dropdown
          direction="left"
          isOpen={dropopen}
          toggle={toggle}
          className="toggle-dot"
        >
          <DropdownToggle>
            <FontAwesomeIcon icon={faEllipsisH} />
          </DropdownToggle>

          <DropdownMenu container="body" className="toggle-dropdown">
            <DropdownItem>
              <span>Share</span>
              <FontAwesomeIcon icon={faShare} />
            </DropdownItem>

            <DropdownItem>
              <span>Edit</span>
              <FontAwesomeIcon icon={faPencilAlt} />
            </DropdownItem>

            <DropdownItem onClick={function noRefCheck() {}}>
              <span> Delete</span>
              <FontAwesomeIcon icon={faTrash} />
            </DropdownItem>

            <DropdownItem onClick={function noRefCheck() {}}>
              <span> Hide poll</span>
              <FontAwesomeIcon icon={faEyeSlash} />
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Card>
    </>
  );
};

export default CreateaPoll;
